import { render } from "./ImprestChiefList.vue?vue&type=template&id=512e3834"
import script from "./ImprestChiefList.vue?vue&type=script&lang=js"
export * from "./ImprestChiefList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__